import React, { useState, useEffect ,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateFormData } from "../../redux/dispatch";
import useRubriqueNav from "../../hooks/useRubriqueNav";
import RubriqueNav from "../shared/RubriqueNav";
import TabDateRecul from "./tabs/TabDateRecul";
import TabClinique from "./tabs/TabClinique";
import TabBilanParaclinique from "./tabs/TabBilanParaclinique";
import TabStatut from "./tabs/TabStatut";
import TabProchainRDV from "./tabs/TabProchainRDV";
import TabMedecins    from "./tabs/TabMedecins";
import "./DernieresNouvelles.css";
import toast from 'react-hot-toast';
import { saveDossier } from "../../redux/dispatch";
import SaveLoader from "../shared/SaveLoader";
import { API_BASE } from "../../config/api";
import noImage from "../../assets/no-image.svg";
const RUBRIQUE = "dernieres_nouvelles";

const TABS = [
  { id: "date_recul",        label: "Date & Recul"        },
  { id: "clinique",          label: "Clinique"            },
  { id: "bilan_paraclinique",label: "Bilan paraclinique"  },
  { id: "statut",            label: "Statut"              },
  { id: "prochain_rdv",      label: "Prochain RDV"        },
  { id: "medecins",          label: "Médecins"            },
];


export const EMPTY_PAGE = () => ({
  // Tab 1
  date:             "",
  recul_fin_trt:    "",
  niveau_etude:   "",
  // Tab 2
  poids:            "",
  taille:           "",
  pb:               "",
  examen_clinique:  "",
  // Tab 3
  bilan_paraclinique: "",
  // Tab 4
  statut:                    "",
  date_deces:  "",
  vivant_rc1:                false,
  vivant_rc2:                false,
  vivant_autre:              false,
  vivant_autre_preciser:     "",
  decede_cancer:             false,
  decede_complication:       false,
  decede_autre:              false,
  decede_autre_preciser:     "",
  abandon_moment_cause:      "",
  complications_long_cours:  "",
  complications_preciser:    "",
  // Tab 5
  prochain_rdv: "",
  nom_prenoms_medecin_1:  "",
  nom_prenoms_medecin_2:  "",
  nom_prenoms_medecin_3:  "",
  medecins: [""],
});

// ── Helper confidence pour les structures en tableau de pages ────────────────
const getColor = (value) => {
  if (value <= 0.5)  return "red";
  if (value < 0.8)   return "orange";
  return "#22c55e";
};

export const getPageConfidence = (pageObj, field, source) => {
  if (!pageObj) return { value: null, color: null, exists: false };
  if (source === "mongodb") return { value: null, color: null, exists: false };
  const raw    = pageObj[`${field}_confidence`];
  const parsed = parseFloat(raw);
  const normalized = (raw === null || raw === undefined || raw === "" || isNaN(parsed)) ? 0 : parsed;
  return { value: normalized, color: getColor(normalized), exists: true };
};

const DernieresNouvelles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id }   = useParams();
  const rawImages = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.images || []);
    const IMAGES = rawImages.length > 0
    ? rawImages.map((img) => `${API_BASE}/${img.chemin_image}`)
    : [noImage];
  const { currentDossier, list } = useSelector((s) => s.dossiers);
  const dossier = currentDossier || list.find((d) => d.id === id) || null;
  const formulairesData  = useSelector((s) => s.formulaires.data);
  const savedPages = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.pages || [EMPTY_PAGE()]);
  const source     = useSelector((s) => s.formulaires.data?.[id]?._source);

  const [pages,     setPages]     = useState(savedPages);
  const [activeTab, setActiveTab] = useState("date_recul");
  const [activePage,setActivePage]= useState(0);
  const [imgIndex,  setImgIndex]  = useState(0);
    const [saving, setSaving] = useState(false);

    const pagesRef = useRef(pages);
    useEffect(() => { pagesRef.current = pages; }, [pages]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setPages(savedPages);
  }, [id]);

  useEffect(() => {
  setImgIndex(activePage < IMAGES.length ? activePage : IMAGES.length - 1);
}, [activePage]);

// APRÈS
const { goNext, goPrev, goTo, suivante, precedente, indexCourant, total } = useRubriqueNav(RUBRIQUE);
  const getPaginationItems = (total, current) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i);
  const items = [];
  items.push(0);
  if (current > 3) items.push("...");
  for (let i = Math.max(1, current - 1); i <= Math.min(total - 2, current + 1); i++) {
    items.push(i);
  }
  if (current < total - 4) items.push("...");
  items.push(total - 1);
  return items;
};

  const handleChange = (field, value) => {
    setPages((prev) => {
      const updated = [...prev];
      updated[activePage] = { ...updated[activePage], [field]: value };
      return updated;
    });
  };

  const handleAddPage = () => {
    setPages((prev) => [...prev, EMPTY_PAGE()]);
    setActivePage(pages.length);
    setActiveTab("date_recul");
  };

  const handleDeletePage = (pageIndex) => {
    setPages((prev) => prev.filter((_, i) => i !== pageIndex));
    setActivePage((prev) => Math.max(0, prev - 1));
  };

  const handleSave = () => {
   dispatch(updateFormData(id, RUBRIQUE, "pages", pagesRef.current));
  };

    useEffect(() => {
      return () => {
        handleSave();
      };
    }, []);

   const handleSaveAll = async () => {
setSaving(true);
     dispatch(updateFormData(id, RUBRIQUE, "pages", pages));
  try {
    const result = await dispatch(saveDossier());
    toast.success(result.message);
    navigate("/");
  } catch (err) {
    toast.error(err.response?.data?.message || "Erreur lors de la sauvegarde");
  }
    finally {
    setSaving(false);
  }
  };

  const handleCancel = () => {
    setPages(savedPages);
  };

  if (!dossier) {
    return (
      <div className="dn-no-dossier">
        <p>Aucun dossier sélectionné.</p>
        <button onClick={() => navigate("/")}>Retour à la liste</button>
      </div>
    );
  }

  const page = pages[activePage] || EMPTY_PAGE();
  // Confidence helper pour la page courante
const gc = (field) => getPageConfidence(page, field, source);

  return (
    <div className="dn-page">
         {saving && <SaveLoader />}
      <header className="dn-header">
        <div className="dn-header-left">
          <button className="dn-back-btn" onClick={() => navigate("/")}>← Retour à la liste</button>
          <div>
            <h1 className="dn-title">Dossier {dossier.numero_dossier || dossier.id}</h1>
            <p className="dn-subtitle">Patient : {dossier.patient} &nbsp;|&nbsp; Service : {dossier.service}</p>
          </div>
        </div>
        <button className="dn-save-btn" onClick={handleSaveAll} disabled={saving}>Sauvegarder les modifications</button>
      </header>

      <div className="dn-body">
        <aside className="dn-image-panel">
          <div className="dn-image-header">
            <span className="dn-rubrique-label">Dernières Nouvelles</span>
            <span className="dn-image-counter">Image {imgIndex + 1} / {IMAGES.length}</span>
          </div>
          <div className="dn-image-viewer">
            <img src={IMAGES[imgIndex]} alt={`Page ${imgIndex + 1}`} className="dn-image" />
          </div>

            <div className="dn-image-nav">
            <button className="dn-nav-btn" onClick={() => setImgIndex((i) => Math.max(0, i - 1))} disabled={imgIndex === 0}>‹</button>
            {getPaginationItems(IMAGES.length, imgIndex).map((item, i) =>
                item === "..." ? (
                <span key={i} className="dn-ellipsis">…</span>
                ) : (
                <button key={i}
                    className={`dn-nav-dot-btn ${imgIndex === item ? "dn-nav-dot-btn--active" : ""}`}
                    onClick={() => setImgIndex(item)}>
                    {item + 1}
                </button>
                )
            )}
            <button className="dn-nav-btn" onClick={() => setImgIndex((i) => Math.min(IMAGES.length - 1, i + 1))} disabled={imgIndex === IMAGES.length - 1}>›</button>
            </div>
        </aside>

        <main className="dn-form-panel">

          {/* ── Pagination pages ── */}
          <div className="dn-pages-bar">
                <div className="dn-pages-tabs">
                    <button className="dn-nav-page-btn" onClick={() => setActivePage((p) => Math.max(0, p - 1))} disabled={activePage === 0}>‹</button>
                    {getPaginationItems(pages.length, activePage).map((item, i) =>
                    item === "..." ? (
                        <span key={i} className="dn-ellipsis">…</span>
                    ) : (
                        <button key={i}
                        className={`dn-page-tab ${activePage === item ? "dn-page-tab--active" : ""}`}
                        onClick={() => setActivePage(item)}>
                        {item + 1}
                        </button>
                    )
                    )}
                    <button className="dn-nav-page-btn" onClick={() => setActivePage((p) => Math.min(pages.length - 1, p + 1))} disabled={activePage === pages.length - 1}>›</button>
                </div>
                <div className="dn-pages-actions">
                    <button className="dn-add-page-btn" onClick={handleAddPage}>+ Ajouter</button>
                    {activePage > 0 && (
                    <button className="dn-delete-page-btn" onClick={() => handleDeletePage(activePage)}>
                        🗑 Supprimer
                    </button>
                    )}
                </div>
            </div>

          {/* ── Tabs ── */}
          <nav className="dn-tabs">
            {TABS.map((tab) => (
              <button key={tab.id}
                className={`dn-tab ${activeTab === tab.id ? "dn-tab--active" : ""}`}
                onClick={() => setActiveTab(tab.id)}>
                {tab.label}
              </button>
            ))}
          </nav>

          {/* ── Contenu ── */}
          <div className="dn-tab-content">
            {activeTab === "date_recul"         && <TabDateRecul         form={page} onChange={handleChange} getConfidence={gc} />}
            {activeTab === "clinique"           && <TabClinique          form={page} onChange={handleChange} getConfidence={gc} />}
            {activeTab === "bilan_paraclinique" && <TabBilanParaclinique form={page} onChange={handleChange} getConfidence={gc} />}
            {activeTab === "statut"             && <TabStatut            form={page} onChange={handleChange} getConfidence={gc} />}
            {activeTab === "prochain_rdv"       && <TabProchainRDV       form={page} onChange={handleChange} getConfidence={gc} />}
            {activeTab === "medecins"     && <TabMedecins    form={page} onChange={handleChange} getConfidence={gc} />}
          </div>

          {/* <div className="dn-form-actions">
            <button className="dn-btn-save" onClick={handleSave}>Enregistrer</button>
            <button className="dn-btn-cancel" onClick={handleCancel}>Annuler</button>
          </div> */}


<RubriqueNav goNext={goNext} goPrev={goPrev} goTo={goTo} suivante={suivante} precedente={precedente} indexCourant={indexCourant} total={total} />        </main>
      </div>
    </div>
  );
};

export default DernieresNouvelles;